<template>
  <div class="basic-info-contanier">
    <b-row>
      <b-col
        :class="{
          'col-md-7': client_name == 'DY',
          'col-md-6': client_name == 'MID',
        }"
      >
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Capacity per session"
              label-for="capacity_per_session"
              :capacity_per_session="capacity_per_session"
              class="capacitySessionDiv"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <b-form-input
                id="capacity_per_session"
                v-bind:class="{
                  'form-control-doomyoga': client_name == 'DY',
                  'form-control-mid': client_name == 'MID',
                }"
                type="number"
                min="1"
                v-model="_capacity_per_session"
                :capacity_per_session="capacity_per_session"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="6" v-if="client_name == 'MID'">
        <b-form-group
          :class="{
            'form-group-vselect-doomyoga': client_name == 'DY',
            'form-group-vselect-mid': client_name == 'MID',
          }"
          :label="field_name + ' category'"
          label-for="event_category"
          :event_category="event_category"
          :label-class="{
            'form-label-doomyoga': client_name == 'DY',
            'form-label-mid': client_name == 'MID',
          }"
        >
          <p
            :class="{
              'error_validation_message_p_dy mx-0': client_name == 'DY',
              error_validation_message_p_mid: client_name == 'MID',
            }"
            v-if="invalid_event_category"
          >
            Please select event category
          </p>
          <v-select
            :options="event_categories_list"
            name="event_category"
            title="event_category"
            v-model="_event_category"
            label="name"
            :reduce="(item) => item.id"
            placeholder="Select event category"
            required
          ></v-select
        ></b-form-group>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import $, { event } from "jquery";

export default {
  name: "EventOtherData",
  props: [
    "client_name",
    "field_name",
    "capacity_per_session",
    "event_category",
    "event_categories_list",
    "invalid_event_category",
  ],

  components: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {
    _capacity_per_session: {
      get() {
        return this.capacity_per_session;
      },
      set(value) {
        // console.log(value);
        this.$emit("update:capacity_per_session", value);
      },
    },
    _event_category: {
      get() {
        return this.event_category;
      },
      set(value) {
        this.$emit("update:event_category", value);
      },
    },
  },
  methods: {},
};
</script>
<style >
</style>


// WEBPACK FOOTER //
// src/components/events/OtherData.vue